exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.draw-box-container[data-v-aa24926c] {\n    width: 320px;\n    height: 320px;\n}\n.console-column[data-v-aa24926c] {\n    max-width: 100%;\n}\n", ""]);

// exports
